import { styled } from "goober";
import type { ReactNode } from "react";
import { Button } from "../../Button";
import { HeaderTitleStack } from "../../HeaderTitleStack";
import { HeaderLeft, SettingsModalHeader } from "../../SettingsLayout";
import { Text } from "../../Text";
import type { Protocol } from "./constants";
import type { IdentityProvider } from "./identityProviders";
import { IdpLogoBadge } from "./IdpLogo";

export const PROTOCOL_LABELS: Record<Protocol, string> = {
  oidc: "OpenID Connect",
  saml: "SAML 2.0",
};

export const SsoModalForm = styled("form")`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`;

const HeaderRight = styled("div")`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
`;

const Tabs = styled("div")`
  display: flex;
  flex-shrink: 0;
  gap: 8px;
`;

export function SsoModalHeader({
  idp,
  title,
  subtitle,
  tabs,
  actions,
  onClose,
}: {
  idp: IdentityProvider;
  title: string;
  subtitle: string;
  tabs?: ReactNode;
  actions?: ReactNode;
  onClose: () => void;
}) {
  return (
    <SettingsModalHeader>
      <HeaderLeft>
        <IdpLogoBadge idp={idp} />
        <HeaderTitleStack>
          <Text variant="text-regular-md" ellipsis>
            {title}
          </Text>
          <Text variant="text-small" color="var(--text-secondary)" ellipsis>
            {subtitle}
          </Text>
        </HeaderTitleStack>
      </HeaderLeft>
      {tabs && <Tabs>{tabs}</Tabs>}
      <HeaderRight>
        {actions}
        <Button size="l" variant="secondary" icon="x" onClick={onClose} />
      </HeaderRight>
    </SettingsModalHeader>
  );
}
